import * as _helperEnvironmentVisitor3 from "@babel/helper-environment-visitor";
var _helperEnvironmentVisitor2 = _helperEnvironmentVisitor3;
try {
  if ("default" in _helperEnvironmentVisitor3) _helperEnvironmentVisitor2 = _helperEnvironmentVisitor3.default;
} catch (e) {}
import * as _core3 from "@babel/core";
var _core2 = _core3;
try {
  if ("default" in _core3) _core2 = _core3.default;
} catch (e) {}
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rewriteThis;
var _helperEnvironmentVisitor = _helperEnvironmentVisitor2;
var _core = _core2;
const {
  numericLiteral,
  unaryExpression
} = _core.types;
const rewriteThisVisitor = _core.traverse.visitors.merge([_helperEnvironmentVisitor.default, {
  ThisExpression(path) {
    path.replaceWith(unaryExpression("void", numericLiteral(0), true));
  }
}]);
function rewriteThis(programPath) {
  (0, _core.traverse)(programPath.node, Object.assign({}, rewriteThisVisitor, {
    noScope: true
  }));
}

//# sourceMappingURL=rewrite-this.js.map
export default exports;